<div class="main-div">
  @if (impersonatedBy) {
    <app-warning-banner>
      You are viewing and acting as
      <strong>{{ impersonatedPersonName }}</strong
      >.
    </app-warning-banner>
  }
  @if (isInTestMode) {
    <app-warning-banner
      >Test mode is on. <strong>Emails won't be sent</strong>, but you can
      continue using the portal.</app-warning-banner
    >
  }
  <div fxHide.lt-md>
    <app-navbar userName="User Name"></app-navbar>
  </div>
  <mat-sidenav-container class="backg-fixed">
    <mat-sidenav
      [opened]="!mobileQuery.matches"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      #sidenav
    >
      <app-sidebar-list
        userName="User Name"
        (sidebarClose)="onNavClick(sidenav)"
      ></app-sidebar-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <app-sidebar-mobile-header
        (sidebarToggle)="sidenav.toggle()"
      ></app-sidebar-mobile-header>
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
